<template>
    <div class="home">
        <Nav/>
        <div class="banner-img">
            <img src="../assets/06.png"/>
        </div>
        <div class="main">
            <div class="pro-info">
                <div>
                    <h3>产品描述</h3>
                    <div class="mt25">金易贷是一款短期的纯信用过桥借款。借款人在取得银行的抵押贷款批复后，可提用“金易贷”以归还原金融机构的抵押贷款，最终再以银行的新增抵押贷款归还“金易贷”。
                    </div>
                </div>
                <div>
                    <h3>申贷条件</h3>
                    <div class="mt25">① 有房人士；</div>
                    <div>②	房产抵押在银行机构；</div>
                    <div>③	新的贷款银行已出贷款承诺函(批复)；</div>
                    <div>④	征信良好；</div>
                </div>
                <div>
                    <h3>申贷流程</h3>
                    <img class="mt25" src="../assets/goldeasy_process.jpg">
                </div>
                <div>
                    <h3>所需材料</h3>
                    <div class="mt25">① 借款人的身份证复印件及共借人身份证复印件</div>
                    <div>② 户口本或结婚证或离婚证（离婚协议）</div>
                    <div>③ 借款人征信报告（必须有）、共借人征信报告（如有）</div>
                    <div>④ 房产证</div>
                    <div>⑤ 抵押物查册资料</div>
                    <div>⑥ 银行贷款承诺书（批复）</div>
                    <div>⑦ 原银行借款合同及还款记录</div>
                    <div>⑧ 公证委托书及借款合同</div>
                    <div>⑨ 主借款人为企业的，还需：</div>
                    <div>营业执照（三证合一）</div>
                    <div>企业征信报告</div>

                </div>
                <div>
                    <h3>贷款费用</h3>
                    <div class="mt25">年化14%，按实际使用天数计算，最低计息天数为3天</div>
                </div>
                <div>
                    <h3>还款方式</h3>
                    <div class="mt25">到期一次性还本付息</div>
                </div>
                <div>
                    <h3>逾期处理方式</h3>
                    <div class="mt25">无逾期罚息</div>
                </div>
                <div>
                    <h3>业务投诉电话</h3>
                    <div class="mt25">4008-830-822</div>
                </div>
            </div>
            <Foot class="mt100"/>
        </div>
    </div>
</template>

<script>
import Nav from './Nav';
import Foot from './Foot';

export default {
  name: 'Home',
  components: { Nav, Foot },
  props: {},
  methods: {
    effectiveLoanEvent() {
      this.$router.push({ path: `/permission/index?${+new Date()}` });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .home {
        .banner-img {
            img {
                width: 100%;
            }
        }
        .main {
            height: 729px;
            padding-bottom: 100px;
            .pro-info {
                position: relative;
                margin-left: 25%;
                .black-bl {
                    position: absolute;
                    top: -17px;
                    color: rgba(51, 47, 43, 1);
                    font-weight: 500;
                    font-size: 26px;
                }
                div {
                    font-size: 13px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    color: rgba(142, 142, 142, 1);
                    line-height: 26px;
                }
                .mt25 {
                    margin-top: 25px;
                }
                h3 {
                    padding-top: 70px;
                    font-size: 20px;
                    color: rgba(51, 47, 43, 1);
                }
                .mt40 {
                    margin-top: 40px;
                }
                .ml60 {
                    margin-left: 3.125%;
                }
            }
        }

    }

</style>
